import { isPdfRenderedExtension } from '@air/utils-clips';

import { type WorkspaceAgentThumbnail } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/workspaceAgentThumbnailTypes';

type WorkspaceAgentAssetListRowMetaLabelInput = Pick<WorkspaceAgentThumbnail, 'ext' | 'height' | 'width'>;

/** List row subtitle: pixel dimensions (when known) and extension — not file size or duration. */
export const getWorkspaceAgentAssetListRowMetaLabel = ({
  ext,
  height,
  width,
}: WorkspaceAgentAssetListRowMetaLabelInput) => {
  const parts: string[] = [];

  if (width && height && (!ext || !isPdfRenderedExtension(ext))) {
    parts.push(`${width} × ${height}`);
  }

  if (ext) {
    parts.push(ext.toUpperCase());
  }

  return parts.length > 0 ? parts.join(' · ') : null;
};
